import {Component, inject, OnInit} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import {CommissioningService} from "../../../../services/commissioning-service";
import { Link, SiToastNotificationService, ToastStateName } from '@simpl/element-ng';


@Component({
  selector: 'steps-routing',
  templateUrl: 'step-routing.component.html',
  providers: [MessageService],
  styleUrls: [
    'step-routing.component.scss'
  ]
})
export class StepRoutingComponent implements OnInit {
  items: MenuItem[];
  subscription: Subscription;

  private toastNotificationService = inject(SiToastNotificationService);
  constructor(
    public messageService: MessageService,
    public ticketService: CommissioningService) {}

  ngOnInit() {
    this.items = [
      {
        label: 'Pre-Cleaning',
        routerLink: 'precleaning',
        icon: "pi-check"
      },
      {
        label: 'HVAC',
        routerLink: 'hvac'
      },
      {
        label: 'IOs',
        routerLink: 'io'
      },
      {
        label: 'Input',
        routerLink: 'input'
      },
      {
        label: 'Output',
        routerLink: 'output'
      },
      {
        label: 'Sensor',
        routerLink: 'sensor'
      },
      {
        label: 'Layout',
        routerLink: 'layout'
      }

    ];


    this.subscription = this.ticketService.paymentComplete$.subscribe((personalInformation) => {
      this.messageService.add({ severity: 'success', summary: 'Order submitted', detail: 'Dear, ' + personalInformation.firstname + ' ' + personalInformation.lastname + ' your order completed.' });
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
